module.exports = __webpack_public_path__ + "img/T88.9c3cd27f.jpg";